import _ from "lodash";
import { ofType } from "redux-observable";
import { forkJoin } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { getUMAPfromKeyPhrases, getTaxonomyGroups, getGroupColors } from "../helperFunctions";

// types
const TOGGLE_CHECKED_TAG = "TOGGLE_CHECKED_TAG";
const ADD_CHECKED_TAGS = "ADD_CHECKED_TAGS";
const REMOVE_ALL_CHECKED_TAGS = "REMOVE_ALL_CHECKED_TAGS";
export const TAXONOMY_TAGS = "TAXONOMY_TAGS";
export const TAXONOMY_GROUPS = "TAXONOMY_GROUPS";
export const TAXONOMY_DATA = "TAXONOMY_DATA";

// actions
export const toggleCheckedTag = (text, tag) => ({
  type: TOGGLE_CHECKED_TAG,
  payload: { text: text, tag: tag },
});
export const addCheckedTags = (text, tags) => ({
  type: ADD_CHECKED_TAGS,
  payload: { text: text, tags: tags },
});
export const removeAllCheckedTags = (text) => ({
  type: REMOVE_ALL_CHECKED_TAGS,
  payload: {
    text: text,
  },
});
const taxonomyGroups = (groups) => ({ type: TAXONOMY_GROUPS, payload: groups });
const taxonomyData = (data) => ({ type: TAXONOMY_DATA, payload: data });

// epics
export const taxonomyPositionsEpic = (action$) =>
  action$.pipe(
    ofType(TAXONOMY_TAGS),
    switchMap((action) => {
      return forkJoin({
        text: [action.payload.text],
        umap: forkJoin([getUMAPfromKeyPhrases(action.payload.tags), [action.payload.tags]]),
      });
    }),
    map((data) => taxonomyGroups(data)),
  );

export const taxonomyGroupsEpic = (action$) =>
  action$.pipe(
    ofType(TAXONOMY_GROUPS),
    switchMap((action) =>
      forkJoin({
        text: [action.payload.text],
        groups: getTaxonomyGroups(action.payload.umap[0], action.payload.umap[1]),
      }),
    ),
    map((data) => taxonomyData(data)),
  );

// reducer
export const taxonomyReducer = (state = {}, action) => {
  switch (action.type) {
    case TAXONOMY_DATA:
      const newState = _.cloneDeep(state);
      if (state[action.payload.text] === undefined) {
        newState[action.payload.text] = action.payload.groups;
      }
      state = newState;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};

export const taxonomyColorReducer = (state = [], action) => {
  switch (action.type) {
    case TAXONOMY_DATA:
      state = getGroupColors(Object.keys(action.payload).length);
      return state;
    default:
      return state;
  }
};

export const checkedTagsReducer = (state = {}, action) => {
  switch (action.type) {
    case TOGGLE_CHECKED_TAG:
      const newState = _.cloneDeep(state);
      if (!_.isEmpty(state[action.payload.text])) {
        const tagIndex = _.findIndex(newState[action.payload.text], (tag) => tag === action.payload.tag);
        if (tagIndex === -1) {
          newState[action.payload.text].push(action.payload.tag);
        } else {
          newState[action.payload.text] = _.reject(
            newState[action.payload.text],
            (ignore, index) => tagIndex === index,
          );
        }
      } else {
        newState[action.payload.text] = [action.payload.tag];
      }
      state = newState;
      return _.cloneDeep(state);
    case ADD_CHECKED_TAGS:
      const newStateI = _.cloneDeep(state);
      if (!_.isEmpty(state[action.payload.text])) {
        newStateI[action.payload.text] = _.union(newStateI[action.payload.text], action.payload.tags);
      } else {
        newStateI[action.payload.text] = action.payload.tags;
      }
      state = newStateI;
      return _.cloneDeep(state);
    case REMOVE_ALL_CHECKED_TAGS:
      const newStateII = _.cloneDeep(state);
      newStateII[action.payload.text] = [];
      state = newStateII;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};

export const taxonomyTagsAndPositionsReducer = (state = {}, action) => {
  switch (action.type) {
    case TAXONOMY_GROUPS:
      const newState = _.cloneDeep(state);
      if (state[action.payload.text] === undefined) {
        newState[action.payload.text] = action.payload.umap;
      }
      state = newState;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};
